import { getParentByDataAttribute } from "../helper/helper";

export function initMbModal() {
  /**
   * add backdrop to body
   */
  const popupBackdrop = document.createElement("div");
  popupBackdrop.classList.add("mb-modal--backdrop");
  document.body.appendChild(popupBackdrop);

  /**
   * clickhandler
   */
  document.addEventListener("click", function (e) {
    const popupHandler = e.target.hasAttribute("data-mb-modal")
      ? e.target
      : getParentByDataAttribute(e.target, "data-mb-modal");

    /**
     * open popup
     */
    if (popupHandler) {
      // get popup source
      const popupHandlerSrc = popupHandler.getAttribute("data-mb-modal");
      let popupContainer = null;

      // select popupcontainer
      if (popupHandlerSrc.startsWith("#")) {
        popupContainer = document.getElementById(popupHandlerSrc.substr(1));
      } else {
        popupContainer = document.getElementById(popupHandlerSrc);
      }

      // hide all popups
      const visiblePopups = document.querySelectorAll(".mb-modal--visible");

      for (let i = 0; i < visiblePopups.length; i++) {
        visiblePopups[i].classList.remove("mb-modal--visible");
      }

      if (popupContainer) {
        // add close icon
        let closeHandler = popupContainer.querySelector(".mb-modal--close");

        if (!closeHandler) {
          closeHandler = document.createElement("span");
          closeHandler.classList.add("mb-modal--close");
          closeHandler.innerHTML = "×";
          popupContainer.appendChild(closeHandler);
        }

        // show popup
        popupBackdrop.classList.add("mb-modal--backdrop--visible");

        popupContainer.classList.add("mb-modal", "mb-modal--visible");
      }
    }

    /**
     * close popup
     */
    if (
      e.target.classList.contains("mb-modal--close") ||
      e.target.classList.contains("mb-modal--backdrop")
    ) {
      closeModal();
    }
  });

  /**
   * close popup
   */
  function closeModal() {
    popupBackdrop.classList.remove("mb-modal--backdrop--visible");

    // hide all popups
    const visiblePopups = document.querySelectorAll(".mb-modal--visible");

    for (let i = 0; i < visiblePopups.length; i++) {
      visiblePopups[i].classList.remove("mb-modal--visible");
    }
  }
}
